import createStringFacet from '../createStringFacet';

export default createStringFacet({
  stateKey: 'classifications',
  itemKey: 'classification',
});
